import { createAsyncAction } from 'typesafe-actions';
import * as types from './repositoryOrganizationUsage.actionTypes';
import { RepositoryOrganizationUsageState } from './type.d';

export const fetchRepositoryOrganizationUsage = createAsyncAction(
	types.FETCH_REPOSITORY_ORGANIZATION_USAGE_REQUEST,
	types.FETCH_REPOSITORY_ORGANIZATION_USAGE_SUCCESS,
	types.FETCH_REPOSITORY_ORGANIZATION_USAGE_FAILED,
)<undefined, RepositoryOrganizationUsageState, { error: string }>();
